import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTutorialContext } from '../context/TutorialContext';

export function useTutorialWithNavigation() {
  const navigate = useNavigate();
  const { setTutorialActions } = useTutorialContext();

  useEffect(() => {
    const handleCreateSalesPage = () => {
      navigate("/onboarding");
      console.log("create sales page");
    };

    const handleChooseOption = () => {
      console.log("choose option");
    };

    const handleOrderBump = () => {
      console.log("order bump");
    };

    const handleSalesAngles = () => {
      console.log("sales angles");
    };

    const tutorialActions: Record<string, () => void> = {
      createSalesPage: handleCreateSalesPage,
      chooseOption: handleChooseOption,
      orderBump: handleOrderBump,
      salesAngles: handleSalesAngles,
    };

    setTutorialActions(tutorialActions);
  }, [navigate, setTutorialActions]);
}
